import { useState } from 'react'
import { Icon } from '@iconify/react'
import { Controller } from 'react-hook-form'

const ICON_STYLE_CONFIG = {
  base: 'text-2xl text-gray-accent',
}

export default function DropDownList({
  options,
  control,
  name,
  title,
  color = 'white',
  width = 'w-full', // Added width prop with default value
  itemWidth = 'w-[190px] lg:w-[200px]',
}) {
  const [isOpen, setIsOpen] = useState(false)
  const SelectStyling = `whitespace-nowrap ${width} hover:bg-lightgray text-gray-accent lg-c:px-4 lg-c:py-2 px-3 py-1 rounded-lg border border-gray-300 focus:outline-none bg-${color} bg-opacity-60`

  const handleToggle = () => setIsOpen(!isOpen)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        const selectedOption = options.find((option) => option.value === value)

        const handleSelect = (option) => {
          if (selectedOption?.value === option.value) {
            onChange(null) // Clear selection
          } else {
            onChange(option.value)
          }
          setIsOpen(false) // Close dropdown after selection
        }

        return (
          <div className={`relative inline-block text-left ${width}`}>
            <button
              className={SelectStyling}
              onClick={handleToggle}
              type="button"
            >
              <div className="flex w-full items-center justify-between gap-3">
                {selectedOption?.label || title ? (
                  <span>{selectedOption?.label || title}</span>
                ) : null}
                <Icon
                  icon="ph:caret-down-bold"
                  className={ICON_STYLE_CONFIG.base}
                />
              </div>
            </button>
            {isOpen && (
              <div
                className={`${itemWidth} absolute right-0 z-10 mt-1 flex max-h-[400px] flex-wrap overflow-y-auto rounded-lg border border-gray-300 bg-white px-2 shadow-lg transition-opacity duration-300 ease-in-out`}
              >
                <ul className="w-full">
                  {options.map((option) => {
                    const optionClass = `
                      py-2 px-2 my-1 cursor-pointer text-gray w-full 
                      ${
                        selectedOption?.value === option.value && !option.color
                          ? 'bg-gray-200 hover:bg-gray-100'
                          : ''
                      }
                      ${
                        option.color
                          ? `bg-${option.color} text-white hover:bg-opacity-80`
                          : 'hover:bg-gray-100'
                      }
                    `
                    return (
                      <li
                        key={option.value}
                        className={optionClass}
                        onClick={() => handleSelect(option)}
                      >
                        {option.label}
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
          </div>
        )
      }}
    />
  )
}
